var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { PageLoader } from '@soluto-private/mx-asurion-ui-react';
import React from 'react';
import { AsurionDiv } from '../BaseComponents';
import styled from 'styled-components';
import { Labels as LabelsJP } from '../../locales/JP/paymentProcessing';
import { Labels as LabelsUS } from '../../locales/US/paymentProcessing';
import { Labels as LabelsUK } from '../../locales/UK/paymentProcessing';
import { Labels as LabelsEnAU } from '../../locales/en-AU/paymentProcessing';
import { Labels as LabelsEnSG } from '../../locales/en-SG/paymentProcessing';
import { Labels as LabelsMsMY } from '../../locales/ms-MY/paymentProcessing';
import { Labels as LabelsEnTH } from '../../locales/en-TH/paymentProcessing';
import { Labels as LabelsThTH } from '../../locales/th-TH/paymentProcessing';
import { Locale } from '../../common/Constants';
var PaymentProcessingWrapper = styled(AsurionDiv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n\n    div:has(&) {\n        padding: 2.5px;\n    }\n\n    background-color: rgba(255, 255, 255, 0.95);\n    backdrop-filter: grayscale(1) blur(1px);\n"], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n\n    div:has(&) {\n        padding: 2.5px;\n    }\n\n    background-color: rgba(255, 255, 255, 0.95);\n    backdrop-filter: grayscale(1) blur(1px);\n"])));
export var PaymentProcessing = function (props) {
    var _a;
    var locale = props.locale || Locale.US;
    var labels = (_a = {},
        _a[Locale.US] = LabelsUS,
        _a[Locale.JP] = LabelsJP,
        _a[Locale.UK] = LabelsUK,
        _a[Locale.enAU] = LabelsEnAU,
        _a[Locale.enSG] = LabelsEnSG,
        _a[Locale.msMY] = LabelsMsMY,
        _a[Locale.enTH] = LabelsEnTH,
        _a[Locale.thTH] = LabelsThTH,
        _a)[locale];
    var label = (labels === null || labels === void 0 ? void 0 : labels.paymentProcessing) || '';
    return (React.createElement(PaymentProcessingWrapper, null,
        React.createElement(PageLoader, null, label)));
};
var templateObject_1;
